export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const REGISTER_START = 'REGISTER_START';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const FETCH_LIST_START = 'FETCH_LIST_START';
export const FETCH_ROLE_SUCCESS = 'FETCH_ROLE_SUCCESS';
export const FETCH_POSITION_SUCCESS = 'FETCH_POSITION_SUCCESS';
export const FETCH_LIST_FAIL = 'FETCH_LIST_FAIL';

export const UPDATE_CONFIRMATION = 'UPDATE_CONFIRMATION';

export const FETCH_CURRENT_USER = 'FETCH_CURRENT_USER';

export const FETCH_SIGN_UP_STATUS = 'FETCH_SIGN_UP_STATUS';
export const UPDATE_SIGN_UP_STATUS = 'UPDATE_SIGN_UP_STATUS';
